import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BackHeader, PageTemplate } from '@_widgets/common';

import { feedbackApi } from '@_entities/system';

import { Button } from '@_shared/ui/Button';
import { InformationPopup } from '@_shared/ui/Popup';
import { Typography } from '@_shared/ui/Typography';

import * as S from './FeedbackPage.style';

const FEEDBACK_MAX_LENGTH = 500;

export function FeedBackPage() {
	const [text, setText] = useState<string>('');
	const [isOpen, setIsOpen] = useState(false);
	const navigate = useNavigate();

	const openOverlay = () => {
		setIsOpen(true);
	};

	const closeOverlay = () => {
		setIsOpen(false);
	};

	return (
		<PageTemplate
			header={<BackHeader>의견 보내기</BackHeader>}
			nav={
				<S.BottomSubmitButtonWrapper>
					<Button
						bgColor={text.length > 0 ? 'orange-primary' : 'warmgray-300'}
						disabled={text.length <= 0}
						fullWidth
						type="button"
						onClick={() => {
							// @MEMO: Test 중.. 기존 방식은 Feedback 이 전송되어야지만, 팝업이 뜨면서 페이지를 벗어날 수 있었지만, 일단 요청만 보내지면 response가 오는건 큰 의미가 없어서 Promise 기다리지 않는 코드로 수정
							feedbackApi.postFeedback(text);
							openOverlay();
						}}
					>
						<Typography type="title-large" color="white-primary">
							의견 보내기
						</Typography>
					</Button>
				</S.BottomSubmitButtonWrapper>
			}
		>
			{/* After Submit Popup */}
			{isOpen && (
				<InformationPopup.Container closePopup={closeOverlay}>
					<InformationPopup.TextContainer>
						<InformationPopup.Title>소중한 의견 감사합니다!</InformationPopup.Title>
						<InformationPopup.SubText>
							더욱 발전하는 딸깍이 되겠습니다 :)
						</InformationPopup.SubText>
					</InformationPopup.TextContainer>
					<Button
						type="button"
						bgColor="orange-secondary"
						fullWidth
						height="44px"
						onClick={() => {
							closeOverlay();
							navigate(-1);
						}}
					>
						<Typography type="title-large" color="orange-primary">
							확인
						</Typography>
					</Button>
				</InformationPopup.Container>
			)}

			<S.Container>
				<Typography type="title-large" color="font-secondary">
					서비스 제안, 칭찬, 불편한 점, 바라는 점 등
					<br />
					자유롭게 남겨주세요!
				</Typography>
				<Typography type="title-small" color="font-tertiary">
					남겨주신 의견은 딸깍 운영에 큰 도움이 됩니다:)
				</Typography>
				<S.TextArea
					placeholder="내용을 입력하세요."
					maxLength={FEEDBACK_MAX_LENGTH}
					value={text}
					onChange={(e) => {
						if (text.length <= FEEDBACK_MAX_LENGTH) {
							setText(e.target.value);
						}
					}}
					required
				/>
				<S.TextCountParagraph>
					<Typography type="label-large" color="warmgray-400">
						{text.length}/{FEEDBACK_MAX_LENGTH}
					</Typography>
				</S.TextCountParagraph>
			</S.Container>
		</PageTemplate>
	);
}
